import { dispatchServiceIsLoading } from '../../reducers/Rest/loadingStates';

export const isLoading = (dispatch, endpoint, truth, data) => dispatchServiceIsLoading(dispatch, endpoint, truth, data);
